import { useMutation } from 'react-query';

import {} from 'src/core/api/hooks/useMutation';
import { postV2ApiCompanyIdInternationalTransfersRecipientRequirements } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest } from 'src/client/spendesk-api-types';

type Payload =
  PostV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest['body'];

export const useRefreshInternationalRecipientRequirementsMutation = (
  companyId: string,
) => {
  return useMutation(async (payload: Payload) => {
    const response =
      await postV2ApiCompanyIdInternationalTransfersRecipientRequirements({
        body: payload,
        path: { companyId },
      });
    if (response.statusCode !== 200) {
      throw new Error('Failed to fetch recipient requirements');
    }

    return response.body.data.requirements;
  });
};
